<app-funnel-shell>
  <div class="funnel-card checkout">
    @switch (mode()) {

      @case ('forwarding') {
        <p class="funnel-card__intro">{{ 'funnel.direct.forwarding' | translate }}</p>
      }

      @case ('existing') {
        <h1>{{ 'funnel.direct.existing.title' | translate }}</h1>
        <p class="funnel-card__intro">
          {{ (hasPassword() ? 'funnel.direct.existing.body_password' : 'funnel.direct.existing.body_link') | translate:{ email: email } }}
        </p>
        <p class="funnel-card__footnote">{{ 'funnel.check_email.spam_hint' | translate }}</p>
        <div class="checkout__actions">
          <button cButton color="primary" class="w-100" type="button" (click)="signIn()">
            {{ 'funnel.direct.existing.sign_in' | translate }}
          </button>
          <button class="checkout__link" type="button" (click)="backToForm()">
            {{ 'funnel.direct.existing.other_email' | translate }}
          </button>
        </div>
      }

      @case ('checkout') {
        <div class="funnel-eyebrow">{{ 'funnel.direct.eyebrow' | translate }}</div>
        <h1>{{ 'funnel.direct.title' | translate }}</h1>

        <!-- ONE product, ONE price (customer decision 2): the $85 is visible before the form. -->
        <section class="checkout__product">
          <img class="checkout__card" src="/assets/funnel/platinum-card.png" width="1000" height="643"
               [alt]="'funnel.direct.product_name' | translate" />
          <div class="checkout__product-name">{{ 'funnel.direct.product_name' | translate }}</div>
          <p class="checkout__product-text">{{ 'funnel.direct.tagline' | translate }}</p>

          <div class="checkout__price">
            <div class="checkout__price-total">
              <span>{{ 'funnel.direct.price.total_label' | translate }}</span>
              <strong>${{ price.total }}</strong>
            </div>
            <ul class="checkout__price-split">
              <li>
                <span>{{ 'funnel.direct.price.now_label' | translate }}</span>
                <strong>${{ price.checkout }}</strong>
              </li>
              <li>
                <span>{{ 'funnel.direct.price.activation_label' | translate }}</span>
                <strong>${{ price.activation }}</strong>
              </li>
            </ul>
            <p class="checkout__price-note">
              {{ 'funnel.direct.price.summary' | translate:{ total: price.total, now: price.checkout, fee: price.activation } }}
            </p>
            <p class="checkout__once">{{ 'funnel.direct.price.one_time' | translate }}</p>
          </div>

          <p class="checkout__hint">{{ 'funnel.direct.payment_hint' | translate }}</p>
          <p class="checkout__hint">{{ 'funnel.direct.kyc_hint' | translate }}</p>
        </section>

        <form (ngSubmit)="submit()" (focusin)="onFormFocus()" novalidate>
          <h2 class="checkout__heading">{{ 'funnel.direct.details_title' | translate }}</h2>
          <input class="form-control mb-2" type="text" name="first_name" autocomplete="given-name"
                 [placeholder]="'funnel.landing.first_name_placeholder' | translate"
                 [(ngModel)]="firstName" (ngModelChange)="onInput()" />
          <input class="form-control mb-2" type="text" name="last_name" autocomplete="family-name"
                 [placeholder]="'funnel.landing.last_name_placeholder' | translate"
                 [(ngModel)]="lastName" (ngModelChange)="onInput()" />
          <input class="form-control mb-2" type="email" name="email" autocomplete="email"
                 [placeholder]="'funnel.landing.email_placeholder' | translate"
                 [(ngModel)]="email" (ngModelChange)="onInput()" />
          <label class="checkout__language">
            <span>{{ 'funnel.direct.language_label' | translate }}</span>
            <select class="form-select" name="language" [ngModel]="language()" (ngModelChange)="setLanguage($event)">
              @for (l of languages; track l.code) {
                <option [ngValue]="l.code">{{ l.label }}</option>
              }
            </select>
          </label>
          <p class="funnel-card__footnote mt-1">{{ 'funnel.direct.account_note' | translate }}</p>

          <h2 class="checkout__heading">{{ 'funnel.direct.legal_title' | translate }}</h2>
          @if (documentsLoading()) {
            <p class="checkout__muted">{{ 'funnel.direct.legal_loading' | translate }}</p>
          } @else if (documentsError()) {
            <p class="text-danger small">
              {{ 'funnel.direct.legal_error' | translate }}
              <button class="checkout__link" type="button" (click)="loadDocuments()">{{ 'funnel.direct.retry' | translate }}</button>
            </p>
          } @else {
            @for (doc of documents(); track doc.key) {
              <div class="checkout__consent" [class.checkout__consent--missing]="missing().includes(doc.key)">
                <input type="checkbox" [id]="'consent-' + doc.key" [checked]="!!checked()[doc.key]"
                       (change)="toggle(doc.key, $any($event.target).checked)" />
                <label [for]="'consent-' + doc.key">
                  {{ doc.checkbox | translate }}
                  <a href="#" (click)="openDocument(doc, $event)">{{ 'funnel.direct.read' | translate:{ title: doc.title } }}</a>
                </label>
              </div>
            }
          }

          <div class="my-3">
            <div id="mcaptcha-widget"></div>
            @if (captchaError() && !captchaToken()) {
              <small class="text-danger">{{ 'funnel.landing.captcha_required' | translate }}</small>
            }
          </div>

          <button cButton color="primary" type="submit" class="w-100" [disabled]="!canSubmit()">
            @if (loading()) {
              {{ 'funnel.direct.submitting' | translate }}
            } @else {
              {{ 'funnel.direct.submit' | translate:{ now: price.checkout } }}
            }
          </button>

          @if (error()) {
            <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
          }
        </form>

        <a class="checkout__back" href="/">{{ 'funnel.direct.back_to_website' | translate }}</a>
      }
    }

    @if (sponsorId()) {
      <p class="funnel-card__footnote">
        {{ 'funnel.landing.referred_by' | translate }}: <strong>#{{ sponsorId() }}</strong>
      </p>
    }
  </div>
</app-funnel-shell>
